/** Check a printed GTIN literally; never pad, repair or replace its digits. */
export function validGtinChecksum(code) {
    if (!/^(?:\d{8}|\d{12}|\d{13}|\d{14})$/.test(code))
        return false;
    let sum = 0;
    for (let index = code.length - 2, weight = 3; index >= 0; index--, weight = weight === 3 ? 1 : 3) {
        sum += Number(code[index]) * weight;
    }
    return (10 - sum % 10) % 10 === Number(code.at(-1));
}
//# sourceMappingURL=barcode.js.map